import axios from 'axios';
import crypto from 'crypto';
import { v4 as uuidv4 } from 'uuid';
import localForage from 'localforage';
import globals from '../globals';

const ParcelexApi = axios.create({ baseURL: globals().apiUrl });

ParcelexApi.interceptors.request.use(async (config) => {
  const newConfig = { ...config };
  const store = localForage ? (await localForage.getItem('vuex')) : undefined;
  const token = store
    ? store.auth && store.auth.token
    : null;
  newConfig.headers.Authorization = token ? `Bearer ${token}` : '';

  const timestamp = Date.now();
  const nonce = uuidv4();
  const body = config.data ? JSON.stringify(config.data) : '{}';

  const signature = crypto.createHmac('sha256', globals().requestEncryptionKey)
    .update(`${timestamp}:${nonce}:${body}`)
    .digest('hex');

  newConfig.headers['x-timestamp'] = timestamp;
  newConfig.headers['x-nonce'] = nonce;
  newConfig.headers['x-signature'] = signature;
  return newConfig;
});

export default ParcelexApi;
